<template>
  <section>
    <div class="container">
      <custom-title-block :title="title" />
      <uav-types-content-block :types="UAVs" />
      <custom-button @click="openLink">
        <span>ПЕРЕГЛЯНУТИ ВІДЕО ПРО БпЛА</span>
      </custom-button>
    </div>
  </section>
</template>

<script>
import CustomTitleBlock from "@/components/UI/CustomTitle.vue";
import CustomButton from "@/components/UI/CustomButton.vue";
import UavTypesContentBlock from "@/components/main/UAVTypes/modules/UAVTypesContentBlock.vue";

export default {
  name: "uav-types",
  components: {
    UavTypesContentBlock,
    CustomButton,
    CustomTitleBlock,
  },
  data() {
    return {
      title: "ТИПИ БпЛА",
      UAVs: [
        {
          id: 1,
          type: "Крила",
          img: "wings1",
          description:
            "БпЛА для розвідки, коригування вогню, трансляції відео " +
            "та ретрансляції радіосигналів та ураження противника " +
            "підвісним озброєнням – літакового типу",
          descriptionModal:
            "Гроза ворожих НПЗ. “Довгі руки” наших бійців." +
            "Один із найактуальніших та складних напрямів підготовки " +
            "аеророзвідників. Після курсу ви зможете долучитися до команди, " +
            "про яку говорить увесь світ, яка нищить звіра у його барлозі.",
        },
        {
          id: 2,
          type: "FPV",
          img: "wings2",
          description:
            "Дрони з функцією керування “вид від першої особи”" +
            "– швидкі БпЛА-камікадзе, які знищують живу силу та техніку",
          descriptionModal:
            "Революційний засіб ведення бою. Ви зможете влучно кидати " +
            "гранату на відстань до 30 км і нищити ворога і " +
            "його дорогу техніку – з безпечного місця.",
        },
        {
          id: 3,
          type: "Коптери",
          img: "wings3",
          description:
            "БпЛА для розвідки та коригування артилерії, у тому числі " +
            "з пристроями нічного бачення та тепловізорами. " +
            "За потреби використовуються для скидів боєприпасів",
          descriptionModal:
            "Орлині очі наших бійців. Після навчання ви будете " +
            "бачити потенційну небезпеку або приховані можливості, " +
            "зможете попередити про них.",
        },
        {
          id: 4,
          type: "Бомбери",
          img: "wings4",
          description:
            "Скидають боєприпаси на противника. " +
            "Доставляють все необхідне для наших воїнів",
          descriptionModal:
            "Демон для ворогів і янгол для побратимів. Пам’ятаєте рашиста, " +
            "який здався в полон коптеру? Наші пілоти після підготовки " +
            "надсилають окупантам “подарунки“, а побратимам – порятунок.",
        },
      ],
    };
  },
  methods: {
    openLink() {
      window.open("https://youtu.be/AwPJyFP8C9M", "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
span {
  font-family: "UAF Sans H", serif;

  @media (max-width: 767px) {
    font-size: 13px !important;
  }
}
</style>
